const Application = {
    CHEMITY: 'chemity',
    SUSTAINITY: 'sustainity',

    all() {
        return [
            this.CHEMITY,
            this.SUSTAINITY
        ];
    },

    formTranslation(application) {
        return 'Component(Label):application-' + application;
    },
};

const currentApplication = window.location.host.includes(Application.SUSTAINITY) ? Application.SUSTAINITY : Application.CHEMITY;

function isChemity() {
    return currentApplication === Application.CHEMITY;
}

function isSustainity() {
    return currentApplication === Application.SUSTAINITY;
}

export {
    isChemity,
    isSustainity,
    Application
}
